import { DonationFormCategory, TicketingFormCategory } from "@simplyk/common";
import { isSweepstakesCategory } from "@/common/helpers/sweepstakes";

export const getFormCategoryInfo = (formCategory?: DonationFormCategory | TicketingFormCategory) => {
  const isShop = formCategory === TicketingFormCategory.Shop;
  const isLottery = formCategory === TicketingFormCategory.Lottery;
  const isSweepstakes = isSweepstakesCategory(formCategory);
  const isMembership = formCategory === TicketingFormCategory.MembershipV2;
  const isAuction = formCategory === TicketingFormCategory.Auction;
  const isCustom = formCategory === TicketingFormCategory.Custom;
  const isEvent = formCategory === TicketingFormCategory.Event;

  return {
    isShop,
    isLottery,
    isSweepstakes,
    isMembership,
    isAuction,
    isCustom,
    isEvent,
  };
};
